import { useEffect } from "react"

/** Fetch one cursor page at a time, yielding between pages and stopping on errors. */
export function useBackgroundPages(
  query: {
    hasNextPage?: boolean
    isFetching: boolean
    isError: boolean
    fetchNextPage: () => Promise<unknown>
    data?: { pages: unknown[] }
  },
  enabled = true
) {
  const { hasNextPage, isFetching, isError, fetchNextPage } = query
  const pageCount = query.data?.pages.length ?? 0
  useEffect(() => {
    if (!enabled || !hasNextPage || isFetching || isError) return
    const timer = setTimeout(() => {
      void fetchNextPage().catch(() => undefined)
    }, 30)
    return () => clearTimeout(timer)
  }, [enabled, hasNextPage, isFetching, isError, fetchNextPage, pageCount])
}
